import { atom } from "recoil";

export const autoGuestAuthAtom = atom({ key: "AutoGuestAuthAtom", default: false });
